
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton, AppSelect, AppError } from '@/components';
import { usePicwordMapAdd } from '@/modules/picword/map/model/add';
import { ROUTE_NAME_PICWORD } from '@/modules/picword/router';

export default defineComponent({
    name: ROUTE_NAME_PICWORD.MAP.ADD,
    components: { AppFormRow, AppInput, AppCard, AppButton, AppSelect, AppError },
    setup() {
        const { model, v$, actions, iapOptions, fetchIapOptions, SelectableBooster } = usePicwordMapAdd();

        onMounted(async () => {
            await fetchIapOptions();
        });

        return { v$, model, actions, iapOptions, SelectableBooster };
    }
});
